import type { ReactNode } from 'react';

interface OfflineGateProps {
  isOnline: boolean;
  featureName: string;
  children: ReactNode;
}

export default function OfflineGate({ isOnline, featureName, children }: OfflineGateProps) {
  if (isOnline) return <>{children}</>;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '48px 24px',
        minHeight: 260,
      }}
    >
      <span style={{ fontSize: 'var(--fs-4xl)', marginBottom: 16, opacity: 0.6 }} aria-hidden="true">
        &#x2601;&#xfe0f;
      </span>
      <h3 style={{ fontSize: 'var(--fs-lg)', fontWeight: 700, color: 'var(--color-text-primary)', margin: '0 0 8px' }}>
        {featureName} needs a connection
      </h3>
      <p style={{ fontSize: 'var(--fs-sm)', color: 'var(--color-text-secondary)', lineHeight: 1.5, maxWidth: 280 }}>
        This will be back as soon as you reconnect
      </p>
    </div>
  );
}
